module.exports = __webpack_public_path__ + "img/check-circle-grey.b31b151e.svg";